import { render, staticRenderFns } from "./EditPLPage.vue?vue&type=template&id=3499208d&"
import script from "./EditPLPage.vue?vue&type=script&lang=js&"
export * from "./EditPLPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports